export default class CatalogDbType
{
    static SQLSERVER='dbtype-sqlserver'
}